<template>
  <div
    class="toastification"
    @click="$emit('click-toast')"
  >
    <div class="d-flex align-items-start">
      <b-avatar
        v-if="customIconSrc"
        :variant="variant"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
        :src="customIconSrc"
      ></b-avatar>
      <b-avatar
        v-else
        :variant="variant"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon
          :icon="icon"
          size="15"
        />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small
            v-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto "
          @click="$emit('close-toast')"
        >
          <feather-icon
            v-if="!hideClose"
            icon="XIcon"
            class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    customIconSrc: String
  },
}
</script>

<style lang='scss' scoped>

.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}

</style>

<style lang='scss'>

.toastification {
  &.mimirman {
    cursor: pointer;

    .text-body {
      overflow: hidden;
      display: -webkit-box !important;
      -webkit-line-clamp: 10; /* number of lines to show */
      line-clamp: 10;
      -webkit-box-orient: vertical;
    }
  }
}

.dark-layout {
  .toastification {
    &.mimirman {
      .b-avatar-img {
        img {
          border: unset !important;
          filter: invert(98%) sepia(1%) saturate(1762%) hue-rotate(183deg) brightness(93%) contrast(79%);
        }
      }
    }
  }
}

</style>
